var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-image',{attrs:{"image":_vm.image,"caption":_vm.caption}})}
var staticRenderFns = []

export { render, staticRenderFns }